import { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import LogoutModal from './LogoutModal';

const Layout = ({ children }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  return (
    <>
      <div className="flex h-[100dvh] bg-lightbg overflow-hidden">
        <Sidebar onLogoutClick={() => setShowLogoutModal(true)} />

        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto p-5">
            {children}
          </main>
        </div>
      </div>

      {/* Logout Modal - Rendered outside to overlay entire screen */}
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
      />
    </>
  );
};

export default Layout;
